import { Component, Host, h, Prop, Element } from '@stencil/core';
// import Flickity from 'flickity';
import Swiper, { Navigation } from 'swiper';
@Component({
  tag: 'as-product-card-slider',
  styleUrl: 'as-product-card-slider.css',
  shadow: true,
})
export class AsProductCardSlider {
  @Element() el: HTMLElement;

  @Prop() products?: any;
  @Prop() overlay?: any;
  @Prop() channel?: any;
  @Prop() player?: any = null;
  @Prop() photoviewer?: any = null;
  @Prop() trackevent?: any = null;

  // private theme?: string = 'dark';
  // private quickcart?: number = 0;
  // private imagesize?: string = 'small';

  componentWillLoad() {
    if(this.channel) {
      // this.theme = this.channel.productTheme;
      // this.quickcart = this.channel.quickCart;
      // this.imagesize = this.channel.productImageSize;
    }
  }

  
  componentDidLoad() {
   
    // new Flickity(elem, { 
    //   cellAlign: "left",
    //   cellSelector: '.carousel-cell',
    //   percentPosition: true,
    //   pageDots: false,
    // });
    this.setupSwiper();

  }

  render() {
    if(this.products && this.products.length>0) {
      return (
        <Host>
          <div class='product-card-carousel swiper'>
            <div class="swiper-wrapper">
            {this.products?.map((p: any,index: number) => (
              <div class="swiper-slide">
                <as-product-card index={index} overlay={this.overlay} player={this.player} 
                photoviewer={this.photoviewer} key={`product-${index}`} 
                product={p} channel={this.channel} trackevent={this.trackevent}></as-product-card>
              </div>
            ))}
            </div>
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
          </div>
        </Host>
      );
    } else {
      return (
        <Host>
        </Host>
      );
    }

  }

  setupSwiper() {
    var elem: any = this.el?.shadowRoot.querySelector('.product-card-carousel');
    if(elem) {
      const options: any = {};
      if(window.innerWidth > 576) {
        options.modules = [Navigation];
        const nextEl: any = this.el?.shadowRoot.querySelector(`.swiper-button-next`);
        const prevEl: any = this.el?.shadowRoot.querySelector(`.swiper-button-prev`);
        options.navigation = {
          nextEl,
          prevEl,
        };
      }
      try {
      new Swiper(elem, {
        // configure Swiper to use modules
        loop: false,
        grabCursor: true,
        direction: 'horizontal',
        spaceBetween: 10,
        slidesPerView: 'auto',
        edgeSwipeDetection: 'prevent',
        setWrapperSize: true,
        // nested: true,
        ...options
      });
      } catch(e) {
        setTimeout(() => this.setupSwiper(), 100);
      }
    } else {
      setTimeout(() => this.setupSwiper(), 100);
    }
  }

}
